import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getAvailablePhoneCountries = async (domain: string, locales: string[]): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: `communication-provider/available-phone-countries`,
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        params: { locales },
        domain,
    });
}
